import { j as a } from "../../utils-BdNIfrGQ.js";
import e from "../empty/Empty.mjs";
const n = {
  src: "https://cdn.raceroster.com/assets/cerbicons/empty-404--forest.svg",
  alt: "Page not found",
  variant: "illustration"
}, i = ({
  image: t = n,
  heading: o,
  description: s,
  ...r
}) => /* @__PURE__ */ a.jsx(e, { image: t, heading: o, description: s, ...r });
export {
  i as default
};
